import React from 'react';

export const Content = ({
  children,
}: {
  children: React.ReactNode | React.ReactNode[];
}) => {
  return <main className="container p-4 mx-auto md:p-6">{children}</main>;
};
